module.exports = __webpack_public_path__ + "static/media/mobile_prescripción_veterinaria.cefa7edc.jpg";